import { FC } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@components/atoms/Button';
import { useTranslation } from '@hooks/useTranslation';

export interface ErrorRetryPanelProps {
  onRetry: () => void;
}

/** Sprint 47, story-232. Verify failed for a non-token reason: never claims the link is bad. */
export const ErrorRetryPanel: FC<ErrorRetryPanelProps> = ({ onRetry }) => {
  const tSetup = useTranslation('setup');
  return (
    <div className="flex flex-col gap-4" data-testid="setup-verify-error">
      <div className="flex items-start gap-2">
        <AlertTriangle
          aria-hidden="true"
          className="mt-1 h-5 w-5 shrink-0 text-amber-500"
        />
        <h1
          tabIndex={-1}
          className="text-xl font-bold text-gray-900 dark:text-white">
          {tSetup.verifyErrorTitle}
        </h1>
      </div>
      <p className="text-gray-600 dark:text-gray-300">{tSetup.verifyErrorBody}</p>
      <Button fullWidth variant="primary" onClick={onRetry}>
        {tSetup.retry}
      </Button>
    </div>
  );
};

export default ErrorRetryPanel;
